import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  createTheme,
  Dialog, DialogTitle, DialogActions, DialogContent,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CardMedia,
} from '@material-ui/core';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import AlertScreen from 'src/components/Alert';
import moment from 'moment';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import { styled } from '@mui/system';
import { Stack } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { getUser } from 'src/utils/Common';
import { base64Reader } from 'src/utils/storage/StrPhoto'
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import SaveIcon from '@material-ui/icons/Save';
import * as XLSX from 'xlsx';
const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});

const localeMap = {
  tr: trLocale
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
}));

const StyledCardMedia = styled(CardMedia)({
  height: '200px',
  backgroundSize: 'contain',
});


function Banner() {
  const classes = useStyles();
  const [Alert, setAlert] = useState(false);
  const [AlertType, setAlertType] = useState('');
  const [ResponseMessage, setResponseMessage] = useState('');
  const [Loading, setLoading] = useState(false);
  const [BannerData, setBannerData] = useState([]);
  const [Popup, setPopup] = useState(false);
  const [Id, setId] = useState(0);
  const [Uygulama, setUygulama] = useState(0);
  const [Aktif, setAktif] = useState(1);
  const [Aciklama, setAciklama] = useState('');
  const [Resim, setResim] = useState('');
  const [BaslangicTarihi, setBaslangicTarihi] = useState(new Date().toISOString().slice(0, 16));
  const [BitisTarihi, setBitisTarihi] = useState(new Date().toISOString().slice(0, 16));
  const [label, setLabel] = useState("Dosya seçiniz...");
  const SessionUser = getUser();
  const [avatarEmployee, setAvatarEmployee] = useState(null);
  const setPopupOpen = (IdParam) => {
    setId(IdParam);
    if (IdParam !== 0) {
      getApplicationBanner(IdParam);
    } else {
      setUygulama(0);
      setAktif(1);
      setAciklama('');
      setResim('');
      setBaslangicTarihi(new Date().toISOString().slice(0, 16));
      setBitisTarihi(new Date().toISOString().slice(0, 16));
      setAvatarEmployee(null);
    }
    setPopup(true);
  }
  useEffect(() => {
    getApplicationBanner(0);
  }, []);

  const handleSubmit = async (files, allFiles) => {
    setLoading(true);
    let total = files.length;
    let success = 0;
    let base64Result = "";
    for (let i = 0; i < files.length; i++) {
      const file = files[i].file;
      const meta = files[i].meta;
      if (meta.type.indexOf('image') !== -1) {
        base64Result = await base64Reader(file);
      }
    }
    setResim(base64Result);
    setLoading(false);
  }

  const handleSave = () => {


    if (Resim === "" && Id === 0) {
      setAlert(true);
      setAlertType("error");
      setResponseMessage("Lütfen resim ekleyiniz!...");
      return;
    }
    if (Uygulama === 0) {
      setAlert(true);
      setAlertType("error");
      setResponseMessage("Lütfen uygulama seçiniz!...");
      return;
    }
    if (Aciklama === "") {
      setAlert(true);
      setAlertType("error");
      setResponseMessage("Lütfen açıklama giriniz!...");
      return;
    }
    if (BaslangicTarihi === "") {
      setAlert(true);
      setAlertType("error");
      setResponseMessage("Lütfen başlangıç tarihi giriniz!...");
      return;
    }
    if (BitisTarihi === "") {
      setAlert(true);
      setAlertType("error");
      setResponseMessage("Lütfen başlangıç tarihi giriniz!...");
      return;
    }


    setLoading(true);
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const requestData = {
      Id: Id,
      Uygulama: Uygulama,
      Aktif: Aktif,
      Aciklama: Aciklama,
      Resim: Resim,
      BaslangicTarihi: BaslangicTarihi,
      BitisTarihi: BitisTarihi,
      UserId: SessionUser?.UserId
    };

    axios.post('/SetApolloApplicationBanner', requestData, config)
      .then(response => {
        var data = response.data;
        setResponseMessage(data.ErrorDescription);
        setAlert(true);
        setAlertType(data.ErrorCode === "1000" ? "error" : "success");
        setPopup(false);
        getApplicationBanner(0);
      });
    setLoading(false);
  }


  const getApplicationBanner = (IdParam) => {
    setLoading(true);
    axios.get(`/GetApolloApplicationBanner/${IdParam}`)
      .then((response) => {
        const res = response.data;
        if (IdParam === 0) {
          setBannerData(res);
        } else {
          setId(IdParam);
          setUygulama(res[0].UygulamaId);
          setAktif(res[0].AktifId);
          setAciklama(res[0].Aciklama);
          setResim(res[0].Resim);
          setAvatarEmployee(res[0].Resim);
        }

      });
    setLoading(false);
  }

  return (
    <Page className={classes.root}>
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Alert}
        autoHideDuration={10000}
        onClose={event => setAlert(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <AlertScreen
          onClose={event => setAlert(false)}
          variant={AlertType}
          message={ResponseMessage}
        ></AlertScreen>
      </Snackbar>
      <Container maxWidth="xl">
        <Card>
          <CardHeader
            title="Saha Uygulamaları Banner Yönetimi"
            action={
              <Button variant="contained"
                color="secondary"
                endIcon={<AddIcon />}
                onClick={() => setPopupOpen(0)}>
                Yenİ
              </Button>
            }
          />
          <Divider />
          <CardContent>
            <TableContainer >
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Id</TableCell>
                    <TableCell>Uygulama</TableCell>
                    <TableCell>Kullanıcı</TableCell>
                    <TableCell>Aktif</TableCell>
                    <TableCell>Açıklama</TableCell>
                    <TableCell>Başlangıç Tarihi</TableCell>
                    <TableCell>Bitiş Tarihi</TableCell>
                    <TableCell>Kayıt Tarihi</TableCell>
                    <TableCell>Düzenle</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    BannerData.map((item) => (
                      <TableRow hover key={item.Id}>
                        <TableCell>{item.Id}</TableCell>
                        <TableCell>{item.Uygulama}</TableCell>
                        <TableCell>{item.Kullanıcı}</TableCell>
                        <TableCell>{item.Aktif}</TableCell>
                        <TableCell>{item.Aciklama}</TableCell>
                        <TableCell>{item.BaslangicTarihi}</TableCell>
                        <TableCell>{item.BitisTarihi}</TableCell>
                        <TableCell>{item.KayıtTarihi}</TableCell>
                        <TableCell>
                          <IconButton
                            onClick={() => setPopupOpen(item.Id)}
                            aria-label="settings">
                            <RemoveRedEyeIcon

                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={Popup}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Uygulama Banner Yönetimi</DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                disabled
                fullWidth
                id="outlined-disabled"
                label="Id"
                defaultValue={Id}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-age-native-simple">Uygulama</InputLabel>
                <Select
                  label="Uygulama"
                  variant='outlined'
                  value={Uygulama}
                  onChange={(e) => setUygulama(e.target.value)}
                  fullWidth
                  size="small"
                >
                  <MenuItem key={0} value={0}>Uygulama Seçiniz!...</MenuItem>
                  <MenuItem key={1} value={1}>Aron-Yönetim</MenuItem>
                  <MenuItem key={2} value={2}>Artemis</MenuItem>
                  <MenuItem key={3} value={3}>YsPortal</MenuItem>
                  <MenuItem key={4} value={4}>Apollo</MenuItem>
                  <MenuItem key={5} value={5}>Oasis</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-age-native-simple">Aktif</InputLabel>
                <Select
                  label="Aktif"
                  variant='outlined'
                  value={Aktif}
                  onChange={(e) => setAktif(e.target.value)}
                  fullWidth
                  size="small"
                >
                  <MenuItem key={0} value={0}>Pasif</MenuItem>
                  <MenuItem key={1} value={1}>Aktif</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                id="filled-multiline-flexible"
                label="Açıklama"
                multiline
                fullWidth
                rows={5}
                variant="outlined"
                value={Aciklama}
                onChange={(e) => setAciklama(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} lg={6}>
              <TextField
                id="datetime-local"
                label="Başlangıç Tarihi"
                variant="outlined"
                fullWidth
                type="datetime-local"
                value={BaslangicTarihi}
                onChange={(e) => setBaslangicTarihi(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} lg={6}>
              <TextField
                id="datetime-local"
                label="Bitiş Tarihi"
                variant="outlined"
                fullWidth
                type="datetime-local"
                value={BitisTarihi}
                onChange={(e) => setBitisTarihi(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <Dropzone
                onSubmit={handleSubmit}
                inputContent={label}
                submitButtonContent="Yükle"
                accept="image/*"
                maxFiles={1}
                minSize={0}
                maxSize={8072000}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <StyledCardMedia
                component="img"
                alt="Banner"
                src={avatarEmployee}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { handleSave() }}
            endIcon={<SaveIcon />}
          >
            Kaydet
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { setPopup(false); }}
            endIcon={<CloseIcon />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page >
  );
}
export default Banner;
